import DecisionMakersForm from './EmailToTarget/DecisionMakersForm'
import SettingsForm from './EmailToTarget/SettingsForm'
import TemplatesForm from './EmailToTarget/TemplatesForm'

export default function EmailToTargetActionForm({ actionId }) {
  const [tab, setTab] = useState('decisionMakers')

  const tabClasses = (thisTab) => {
    let classes = ['tab']
    if (thisTab === tab) {
      classes.push('selected')
    }
    return classes.join(' ')
  }

  return <div className="box narrow">
    <div className='row margin-bottom'>
      <div className='tabs'>
        <div className={tabClasses('decisionMakers')} onClick={() => setTab('decisionMakers')}>Recipients</div>
        <div className={tabClasses('settings')} onClick={() => setTab('settings')}>Form Settings</div>
        <div className={tabClasses('templates')} onClick={() => setTab('templates')}>Email Settings</div>
      </div>
    </div>

    {tab === 'decisionMakers' && <DecisionMakersForm actionId={actionId} />}
    {tab === 'settings' && <SettingsForm actionId={actionId} />}
    {tab === 'templates' && <TemplatesForm actionId={actionId} />}
  </div>
}

